import { IconButton, IconButtonProps } from "@chakra-ui/react";

export interface CarouselIconButtonProps extends IconButtonProps {
  hoverColor?: string;
  activeColor?: string;
}
export const CarouselIconButton = ({
  hoverColor,
  activeColor,
  ...props
}: CarouselIconButtonProps) => (
  <IconButton
    variant="unstyled"
    boxSize="auto"
    minW="auto"
    display="inline-flex"
    fontSize="2xl"
    color={"blueGray.600"}
    _hover={{
      color: hoverColor || "blue.500",
      _disabled: { color: "blueGray.600" },
    }}
    _active={{ color: activeColor || "blue.600" }}
    _focus={{ boxShadow: "none" }}
    _focusVisible={{ boxShadow: "outline" }}
    {...props}
  />
);
